import IssueDetailModal from './IssueDetailModal';

export default IssueDetailModal;
